import { Form } from './../models/formModel';
import { AppState } from "../reducers/rootReducer";

export const getFormById = (formId: String) => (state: AppState) => { return state.formList.filter((form) => form.id === formId)[0]};